import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, Button, Spinner, Alert } from 'react-bootstrap';
import api from '../../../api/apiClient';

const PaymentFailurePage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get('paymentId');

  const [isLoading, setIsLoading] = useState(!!paymentId);
  const [paymentDetails, setPaymentDetails] = useState(null);

  useEffect(() => {
    const loadStatus = async () => {
      if (!paymentId) {
        setIsLoading(false);
        return;
      }

      try {
        const response = await api.payments.getStatus(paymentId);
        setPaymentDetails(response.data?.data || null);
      } catch (error) {
        console.error('Failed to load payment info', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadStatus();
  }, [paymentId]);

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="danger" />
        <p className="text-muted mt-3 mb-0">Checking payment status...</p>
      </div>
    );
  }

  return (
    <div className="container-fluid px-0">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="fw-bold text-dark mb-1">Payment Failed</h4>
          <p className="text-muted mb-0">The payment could not be completed. Your cart items are still intact.</p>
        </div>
      </div>

      <Card className="border-0 shadow-sm">
        <Card.Body className="p-4 text-center">
          <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-danger bg-opacity-10 mb-3" style={{ width: '96px', height: '96px' }}>
            <i className="fas fa-times text-danger" style={{ fontSize: '38px' }}></i>
          </div>
          <h4 className="fw-bold text-dark">Payment Failed</h4>
          <p className="text-muted mb-4">
            No charges have been made. Please try the payment again or choose a different payment method.
          </p>

          {paymentDetails && (
            <Alert variant="light" className="text-start mx-auto mb-4" style={{ maxWidth: '520px' }}>
              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Payment ID</span>
                <span className="fw-semibold">{paymentDetails.id}</span>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Status</span>
                <span className="fw-semibold text-uppercase text-danger">{paymentDetails.status}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span className="text-muted">Provider</span>
                <span className="fw-semibold text-uppercase">{paymentDetails.paymentType}</span>
              </div>
            </Alert>
          )}

          <div className="d-flex flex-column flex-md-row justify-content-center gap-3">
            <Button variant="danger" className="fw-semibold px-4" onClick={() => navigate('/user/payment/select')}>
              <i className="fas fa-redo me-2"></i>
              Try Again
            </Button>
            <Button variant="outline-secondary" className="fw-semibold px-4" onClick={() => navigate('/user/cart')}>
              <i className="fas fa-shopping-cart me-2"></i>
              Back to Cart
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default PaymentFailurePage;

